import { faLeaf } from '@fortawesome/free-solid-svg-icons';
import * as Types from '../constants/Types';
// import ConfigPHS from './../models/ConfigPHS';

const initialState = {
    isFetching: false,
    isUpdateFetching: false,
    configPHS: []
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.GET_CONFIG_PHS_ACTION:
            return { ...state, isFetching: true, isUpdateFetching: false };
        case Types.GET_CONFIG_PHS_SUCCESS:
            return {
                ...state,
                isFetching: false,
                configPHS: action.phs
            };
        case Types.CONFIG_PHS_UPDATE_ACTION:
            return { ...state, isUpdateFetching: true };
        case Types.CONFIG_PHS_UPDATE_SUCCESS:
            return { ...state, isUpdateFetching: false };
        case Types.CONFIG_PHS_FAIL:
            return { ...state, isFetching: false, isUpdateFetching: false };
        default: 
            return state
    }
}
